<template>
  <Loader v-if="loading"/>
  <div v-else>
    <div class="flex items-center mb-5">
      <router-link :to="{name: 'EmployeeApplicationsResolutionsList'}"
                   class="text-gray-400 bg-gray-100 rounded py-1 px-4 font-medium flex items-center">
        <ArrowLeftIcon class="w-5 h-5 mr-2"/> {{ $lang.app.GO_BACK_TO_RESOLUTIONS }}
      </router-link>
    </div>
    <div v-if="resolution">
      <div class="mb-6">
        <h2 class="text-indigo-700 mb-4 font-bold">{{ $lang.app.RESOLUTION }}</h2>
        <div class="flex mb-2">
          <p class="text-sm text-gray-500 w-1/3">{{ $lang.app.TITLE }}:</p>
          <p :title="$lang.app.TITLE"
             class="text-base w-2/3 px-2 font-medium rounded-sm">
            {{ resolution.title }}
          </p>
        </div>
        <div class="flex mb-2">
          <p class="text-sm text-gray-500 w-1/3">{{ $lang.app.STATUS }}:</p>
          <p :title="$lang.app.STATUS"
             class="text-base w-2/3 px-2 font-bold text-green-500 rounded-sm">
            {{ resolution.statusText }}
          </p>
        </div>
        <Deadline :resolution="resolution" @updated="deadline => resolution.deadline = deadline"/>
        <div v-if="resolution.conclusion?.number" class="flex mb-2">
          <p class="text-sm text-gray-500 w-1/3">{{ $lang.app.CONCLUSION }}:</p>
          <p :title="$lang.app.CONCLUSION" class="text-base w-2/3 px-2 flex justify-between">
            <span>{{ resolution.conclusion.number }}</span>
            <span class="text-gray-400">{{ resolution.conclusion.docDate ? $moment(resolution.conclusion.docDate).format('DD.MM.YYYY HH:mm') : '' }}</span>
          </p>
        </div>
      </div>
      <Executors v-if="resolution.executors && resolution.executors.length"
                 :executors="formatExecutors(resolution.executors)"
                 :resolution="resolution"
                 :user-resolution-role="userResolutionRole"
                 class="mb-4"/>
      <Signers v-if="resolution.signers && resolution.signers.length"
               :signers="resolution.signers"
               :resolution="resolution"
               :user-resolution-role="userResolutionRole"
               class="mb-8">
      </Signers>
      <ResolutionFeedbacks :resolution="resolution"/>

      <div v-if="resolution.history?.length">
        <h5 class="font-bold text-blue-900 mb-1">{{ $lang.app.HISTORY }}</h5>
        <ResolutionVersion v-for="resolutionVersion in resolution.history" :key="resolutionVersion.id"
                            class="mb-3"
                            :resolution-version="resolutionVersion"/>
      </div>
    </div>
  </div>
</template>
<script>
import resolutionApi from "../../../../../../api/employee/resolution"
import Executors from "../../../../../../components/employee/application/resolution/Executors"
import Signers from "../../../../../../components/employee/application/resolution/Signers"
import ResolutionFeedbacks from "../../../../../../components/employee/application/resolution/ResolutionFeedbacks"
import {getValueByKey as edmTypesGetValueByKey} from "../../../../../../helpers/constants/edmTypes";
import {getValueByKey as executorTypesGetValueByKey} from "../../../../../../helpers/constants/executorTypes";
import Deadline from "../../../../../../components/employee/application/resolution/Deadline";
import ResolutionVersion from "../../../../../../components/employee/application/resolution/ResolutionVersion.vue";

export default {
  components: {
    Executors,
    ResolutionFeedbacks,
    Signers,
    Deadline,
    ResolutionVersion,
  },
  data() {
    return {
      loading: false,
      resolution: null,
      userResolutionRole: null,
    }
  },
  created() {
    this.fetchResolution()
  },
  beforeMount() {
    this.$emitter.on('refresh-resolution', () => {
      this.fetchResolution()
    })
  },
  beforeUnmount() {
    this.$emitter.off('refresh-resolution')
  },
  watch: {
    '$route'(value) {
      if(value.name === 'EmployeeApplicationsResolutionsDetail') {
        this.fetchResolution()
      }
    }
  },
  methods: {
    executorTypesGetValueByKey,
    fetchResolution() {
      this.loading = true
      resolutionApi.getResolution(this.$route.params.resolutionId)
          .then(res => {
            this.resolution = res.data
            this.$emitter.emit('set-application-tab', this.resolution)
            this.setUserResolutionRole()
          }).finally(() => {
            this.loading = false
          })
    },
    setUserResolutionRole() {
      if(this.resolution.curator?.id === this.$store.getters.getCurrentUser.employment?.id) {
        this.userResolutionRole = 'ROLE_CURATOR'
      } else if (this.$store.getters.getCurrentUser.employment?.position?.edmType === edmTypesGetValueByKey('HEAD_OF_DEPARTMENT')) {
        this.userResolutionRole = 'ROLE_HEAD_OF_DEPARTMENT'
      } else {
        this.userResolutionRole = this.$store.getters.getCurrentUserRole
      }
    },
    executorType(executor) {
      if(executor.curator) {
        return this.executorTypesGetValueByKey('CURATOR')
      }
      if(executor.responsible) {
        return this.executorTypesGetValueByKey('RESPONSIBLE')
      }
      return this.executorTypesGetValueByKey('EXECUTOR')
    },
    formatExecutors(executors) {
      return executors.map(executor => ({
        id: executor.id,
        type: this.executorType(executor),
        name: executor.employment.fullName,
        position: this.$lang.$translate({
          ru: executor.employment.position.nameRu,
          kg: executor.employment.position.nameKg
        }) + ' | ' + this.$lang.$translate({
          ru: executor.employment.position.department.nameRu,
          kg: executor.employment.position.department.nameKg
        }),
        departmentId: executor.employment.position.department.id
      }))
    }
  }
}
</script>
